// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","vGutterX":"30px","vTopNavHeight":"60px","vPrimary1":"#00a8e2","tablet-up":"(min-width: calc(768 * 1px))","navBar":"NavBar_navBar__36P4w","nav":"NavBar_nav__1FWUI"};